module.exports = __webpack_public_path__ + "img/tokelau.f9738da9.svg";